import React, { useEffect, useRef, useState } from "react";
import "./Style.css";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import EmployeesTable from "../../../Pages/AiLeads/CompanyProfileScreen/EmployeesTable/Index";
import Comingsoon from "../../ComingSoon/ComingSoon";
import Crie from "./Crie/Crie";
import callImg from "../../../Assets/call.svg";
import LoctionImg from "../../../Assets/loction.svg";
import userprofile from "../../../Assets/user.svg";
import GrowIcons from "../../../Assets/grow.svg";
import Companyimg from "../../../Assets/company.svg";
import GlobalImg from "../../../Assets/Globe.svg";
import linkedin from "../../../Assets/linkedin.svg";
import visitLinkImage from "../../../Assets/visit-link.svg";
import IndustryImage from "../../../Assets/office-building.png";
import { Link } from "react-router-dom/dist";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import SpeedIcon from "@mui/icons-material/Speed";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { APIUrlThree, APIUrlToken, GetUserId } from "../../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import greentrendindicator from "../../../Assets/greentrendindicator.svg";
import redtrendindicator from "../../../Assets/redtrendindicator.svg";
import CustomNewsSearchDetails from "./CostomNewsSearchDetails/CostomNewsSearchDetails";
import brelogo from "../../../Assets/breohiologo.svg";
import { Padding } from "@mui/icons-material";
import { APP_CONFIG } from "../../../Utils/env";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CompanyProfileTabs({
  dataForInformation,
  selectedOuterRows,
  setSelectedOuterRows,
  rowData,
  handleToPDF,
  isDecisionMakerExcel,
  setIsDecisionMakerExcel,
  setIsSalesForceTrigger,
  isSalesForceTrigger,
  archiveRecord,
  setArchiveRecord,
  trackRecord,
  setTrackRecord,
  addToFavorite,
  setAddToFavorite,
  setDisableRequestUpdate,
  setRequestUpdateRecord,
  requestUpdateRecord,
  setLeadsRequestModal,
  value,
  setValue,
  handleToPDFCrie,
  handlePrint,
  setShowSalesForce,
  isDownloading,
  componentRef,
  handleTrackingdata,
  informationData,
  industryLogo,
  setIndustryLogo,
  breStatus,
}) {
  const loggedInUserId = GetUserId();
  const [favoritesLeads, setFavoritesLeads] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleMenuDownloadExcel = () => {
    setIsDecisionMakerExcel(true);
    setAnchorEl(null);
  };
  const isBranchLocationsDisabled = true;
  const [favoritesList, setFavoritesList] = React.useState([]);

  const [loading, setLoading] = React.useState(false);
  const listFavoriteRecords = async (e) => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/list_favourite_leads?userid=${Number(
        GetUserId(),
      )}&limit=500&offset=0`,
    };
    try {
      const response = await axios(options);
      setFavoritesList(response?.data?.data);
      setFavoritesLeads(response?.data?.data);
      if (e == 1) {
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    listFavoriteRecords();
  }, []);

  // new add to fav api
  const handleFavouriteLead = () => {
    setLoading(true);

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: [dataForInformation.org_id],
      url: `${APIUrlThree()}/favorites/org/add-record?user_id=${loggedInUserId}`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        informationData();
        // toast.success("Organization added to favorites")
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const handleRemoveFavouriteLead = () => {
    setLoading(true);
    const option = {
      method: "DELETE",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/favorites/delete_favorites_org?user_id=${loggedInUserId}`,
      data: [dataForInformation?.org_id],
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        informationData();
        toast.success("Organization removed from favorites");
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // CRIE Data starts
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    borderRadius: "8px",
  };
  const location = useLocation();
  const isComponyScreen = location?.state?.isComponyScreen;
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("direct");
  //Direct Path States
  const [crieData, setCrieData] = useState([]);
  const [crieDataInitial, setCrieDataInitial] = useState([]);
  const [crieSrcList, setCrieSrcList] = useState([]);
  const [crieDstList, setCrieDstList] = useState([]);
  const [joAssociateList, setJoAssociateList] = useState([]);
  const [organizationAssociateList, setOrganizationAssociateList] = useState(
    [],
  );
  // In direct Path states
  const [crieIndirectData, setCrieIndirectData] = useState([]);
  const [joIndirectAssociateList, setJoIndirectAssociateList] = useState([]);
  const [
    organizationIndirectAssociateList,
    setOrganizationIndirectAssociateList,
  ] = useState([]);
  const [middleAssociateList, setMiddleAssociateList] = useState([]);
  const [criejoIndirectAssociateList, setCrieJoIndirectAssociateList] =
    useState([]);
  const [
    crieorganizationIndirectAssociateList,
    setCrieOrganizationIndirectAssociateList,
  ] = useState([]);
  const [criemiddleAssociateList, setCrieMiddleAssociateList] = useState([]);
  const [disabledIndirect, setDisabledIndirect] = useState("");
  const [modalOpenRefresh, setModalOpenRefresh] = useState(false);
  const [inDirectSummary, setInDirectSummary] = useState();
  const [indirectCount, setIndirectCount] = useState(0);

  const [strengthList, setStrengthList] = useState();
  const [crieStrengthList, setCrieStrengthList] = useState();
  const [crieNavigate, setCrieNavigate] = useState();

  const getCrieIndirectdata = () => {
    setLoading(true);
    const data = {
      // src_id: [process.env.REACT_APP_JOI_JO_ID],
      src_id: [APP_CONFIG.JOI_JO_ID],

      target_id: [dataForInformation?.org_id?.toString()],
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlThree()}/v1/get_initial_indirect_dropdown`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          let data = e?.data?.doc;
          setDisabledIndirect(
            e?.data?.indirect_request || e?.data?.doc?.indirect_request,
          );
          setInDirectSummary(data?.summary);
          setIndirectCount(data?.summary?.number_of_path);
          setOrganizationIndirectAssociateList(data?.summary?.target_nodes);
          setJoIndirectAssociateList(data?.summary?.source_nodes);
          setMiddleAssociateList(data?.summary?.mid_nodes);
          setCrieOrganizationIndirectAssociateList(data?.summary?.target_nodes);
          setCrieJoIndirectAssociateList(data?.summary?.source_nodes);
          setCrieMiddleAssociateList(data?.summary?.mid_nodes);
          setStrengthList(
            data?.summary?.strengths?.map((item) => ({
              name: item,
              value: item,
            })),
          );
          setCrieStrengthList(
            data?.summary?.strengths?.map((item) => ({
              name: item,
              value: item,
            })),
          );
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const getCriedata = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_direct_path?source_id=${
        // process.env.REACT_APP_JOI_JO_ID
        APP_CONFIG.JOI_JO_ID
      }&destination_id=${dataForInformation?.org_id}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          let data = e?.data;
          setCrieData(data?.data);
          setCrieDataInitial(data?.data);
          const dataJo = data?.src_list?.map((item) => ({
            name: item[0],
            value: item[1],
          }));
          const datadest = data?.dst_list?.map((item) => ({
            name: item[0],
            value: item[1],
          }));
          setJoAssociateList(dataJo);
          setCrieSrcList(dataJo);
          setCrieDstList(datadest);
          setOrganizationAssociateList(datadest);
          const storagedata = {
            dataForInformation: dataForInformation,
            crieData: data?.data,
            crieSrcList: datadest,
            organizationAssociateList: datadest,
            joAssociateList: dataJo,
          };
          localStorage.setItem("cdp", JSON.stringify(storagedata));
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getCriedata();
    getCrieIndirectdata();
  }, [isComponyScreen, dataForInformation]);
  const handleInterestRequest = () => {
    setLoading(true);
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 60);
    const trackUntil = currentDate.toISOString().split("T")[0];
    const data = {
      request_type: "crie",
      external_id: null,
      first_name: null,
      last_name: null,
      position_title: null,
      organization_name: null,
      linkedin: null,
      organization_website: null,
      person_id: null,
      org_id: null,
      category: null,
      track_until: trackUntil,
      source_id: APP_CONFIG.JOI_JO_ID,
      // source_id: process.env.REACT_APP_JOI_JO_ID,
      source_name: "jobsohio",
      target_id: String(dataForInformation?.org_id),
      target_name: dataForInformation?.name,
      source: null,
      user_approval: null,
      user_id: Number(GetUserId()),
      user_email: null,
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlThree()}/v1/interest_request`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          setModalOpen(false);
          setModalOpenRefresh(false);
          getCrieIndirectdata();
          toast.success(e?.data?.message);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const [showIndicator, setShowIndicator] = useState(false);

  useEffect(() => {
    if (!dataForInformation?.updated_at) return;
    const currentDate = new Date();
    const updatedDate = new Date(dataForInformation.updated_at);
    const diffInDays = (currentDate - updatedDate) / (1000 * 60 * 60 * 24);
    setShowIndicator(diffInDays <= 30);
  }, [dataForInformation?.updated_at]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getIndustryLogo = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_company_logo_url?org_id=${
        dataForInformation?.org_id
      }`,
    };
    axios(option)
      .then((response) => {
        setIndustryLogo(response?.data?.data?.company_logo_url);
      })
      .catch(() => {});
  };
  useEffect(() => {
    if (dataForInformation?.org_id) {
      getIndustryLogo();
    }
  }, [dataForInformation?.org_id]);
  const [isPortrait, setIsPortrait] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    const handleChange = (e) => {
      setIsPortrait(e.matches);
    };
    setIsPortrait(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Box
      className={
        isMobile
          ? "company-profile-main-tabs-data-mobile"
          : "company-profile-main-tabs-data"
      }
      sx={{ width: "100%" }}
      ref={componentRef}
    >
      <>
        {/* type code here  */}
        <div className="cp_outer_container_leads">
          <div className="cp_inner_container_leads">
            <section className="">
              <div className=" CompanyProfile-outter-container">
                <div className="CompanyProfile-flex-container">
                  <div className="CompanyProfile-flex-outter-container">
                    <div className="CompanyProfile-img">
                      <img
                        src={industryLogo ? industryLogo : IndustryImage}
                        style={{ width: "100%", height: "100%" }}
                        onError={(e) => (e.target.src = IndustryImage)}
                      />
                    </div>
                    {/* condition for mobile responsive changes */}
                    {isMobile ? (
                      <div>
                        <h3
                          className="Netflix-heading"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {dataForInformation?.name
                            ? dataForInformation?.name
                            : "-"}{" "}
                          {breStatus ? <img src={brelogo} alt="" /> : ""}
                          <p
                            style={{
                              fontFamily: "Inter",
                              fontWeight: "500",
                              fontSize: "13px",
                              textAlign: "center",
                              background: "#00A3E0",
                              color: "#ffffff",
                              padding: "2px 4px 2px 4px",
                              borderRadius: "5px",
                            }}
                          >
                            {dataForInformation?.ai_score !== null &&
                            dataForInformation?.ai_score !== undefined
                              ? dataForInformation?.ai_score
                              : "NA"}
                          </p>
                        </h3>

                        <div className="CompanyProfile-content">
                          <img
                            className="CompanyProfile-icons"
                            src={GlobalImg}
                            alt=""
                          />
                          {dataForInformation?.website_url ? (
                            <Link
                              to={dataForInformation?.website_url}
                              target="_blank"
                              className="clickable-link-for-website"
                            >
                              <p>
                                {dataForInformation?.website_url?.split(
                                  "www.",
                                )?.[1]
                                  ? dataForInformation?.website_url?.split(
                                      "www.",
                                    )?.[1]
                                  : dataForInformation?.website_url?.split(
                                        "http://",
                                      )?.[1]
                                    ? dataForInformation?.website_url?.split(
                                        "http://",
                                      )?.[1]
                                    : dataForInformation?.website_url?.split(
                                          "https://",
                                        )?.[1]
                                      ? dataForInformation?.website_url?.split(
                                          "https://",
                                        )?.[1]
                                      : dataForInformation?.website_url}
                              </p>
                            </Link>
                          ) : (
                            <p>Not Available</p>
                          )}
                        </div>
                        <div className="CompanyProfile-content">
                          <img
                            className="CompanyProfile-icons"
                            src={callImg}
                            alt=""
                          />
                          <p>
                            {dataForInformation?.phone_number
                              ? dataForInformation?.phone_number
                              : "Not Available"}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <h3 className="Netflix-heading">
                          {dataForInformation?.name
                            ? dataForInformation?.name
                            : "-"}{" "}
                          {breStatus ? <img src={brelogo} alt="" /> : ""}
                        </h3>
                        <div className="CompanyProfile-content">
                          <img
                            className="CompanyProfile-icons"
                            src={GlobalImg}
                            alt=""
                          />
                          {dataForInformation?.website_url ? (
                            <Link
                              to={dataForInformation?.website_url}
                              target="_blank"
                              className="clickable-link-for-website"
                            >
                              <p>
                                {dataForInformation?.website_url?.split(
                                  "www.",
                                )?.[1]
                                  ? dataForInformation?.website_url?.split(
                                      "www.",
                                    )?.[1]
                                  : dataForInformation?.website_url?.split(
                                        "http://",
                                      )?.[1]
                                    ? dataForInformation?.website_url?.split(
                                        "http://",
                                      )?.[1]
                                    : dataForInformation?.website_url?.split(
                                          "https://",
                                        )?.[1]
                                      ? dataForInformation?.website_url?.split(
                                          "https://",
                                        )?.[1]
                                      : dataForInformation?.website_url}
                              </p>
                            </Link>
                          ) : (
                            <p>Not Available</p>
                          )}
                        </div>
                        <div className="CompanyProfile-content">
                          <img
                            className="CompanyProfile-icons"
                            src={callImg}
                            alt=""
                          />
                          <p>
                            {dataForInformation?.phone_number
                              ? dataForInformation?.phone_number
                              : "Not Available"}
                          </p>
                        </div>
                        <div className="company-profile-mention-main">
                          <div className="company-profile-mention-b1">
                            <img
                              src={linkedin}
                              alt=""
                              style={{ width: "17px", height: "17px" }}
                            />
                            {dataForInformation?.linkedin
                              ? dataForInformation.linkedin.split(".com/")?.[1]
                              : "-"}
                          </div>
                          <div>
                            <a
                              href={dataForInformation?.linkedin}
                              target="_blank"
                            >
                              <img
                                src={visitLinkImage}
                                alt=""
                                style={{ width: "17px", height: "15px" }}
                              />
                            </a>
                          </div>
                        </div>
                        <div className="CompanyProfile-content">
                          <img
                            className="CompanyProfile-icons"
                            src={LoctionImg}
                            alt=""
                          />
                          <p>{`${
                            dataForInformation?.street
                              ? dataForInformation?.street + `,`
                              : dataForInformation?.street === null
                                ? ""
                                : dataForInformation?.street
                          } ${
                            dataForInformation?.location_identifiers
                              ? dataForInformation?.location_identifiers + `,`
                              : dataForInformation?.location_identifiers ===
                                  null
                                ? ""
                                : dataForInformation?.location_identifiers
                          } ${
                            dataForInformation?.postalcode
                              ? dataForInformation?.postalcode + `,`
                              : dataForInformation?.postalcode === null
                                ? ""
                                : dataForInformation?.postalcode
                          } ${
                            dataForInformation?.country
                              ? dataForInformation?.country
                              : dataForInformation?.country === null
                                ? ""
                                : dataForInformation?.country
                          }`}</p>
                        </div>
                      </div>
                    )}
                  </div>
                  {isMobile ? (
                    <div className="CompanyProfile-cont-rightside">
                      <div className="CompanyProfile-content">
                        <SpeedIcon className="CompanyProfile-icons ai-score-icon" />
                        <p>
                          JOI Score -
                          {dataForInformation?.ai_score !== null &&
                          dataForInformation?.ai_score !== undefined
                            ? dataForInformation?.ai_score
                            : "NA"}
                        </p>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={userprofile}
                          alt=""
                        />
                        <p>
                          Employees-
                          {dataForInformation?.num_employees
                            ? dataForInformation?.num_employees
                            : "Not Available"}
                          {showIndicator &&
                            dataForInformation?.num_employees_movement !==
                              0 && (
                              <img
                                style={{
                                  paddingLeft: "10px",
                                  width: "18px",
                                  height: "13px",
                                }}
                                src={
                                  dataForInformation?.num_employees_movement > 0
                                    ? greentrendindicator
                                    : redtrendindicator
                                }
                                alt="Trend Indicator"
                              />
                            )}{" "}
                        </p>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={GrowIcons}
                          alt=""
                        />
                        <p>
                          Annual revenue -
                          {dataForInformation?.revenue_range
                            ? dataForInformation?.revenue_range
                            : "Not Available"}
                          {showIndicator &&
                            dataForInformation?.revenue_range_movement !==
                              0 && (
                              <img
                                style={{
                                  paddingLeft: "10px",
                                  width: "18px",
                                  height: "13px",
                                }}
                                src={
                                  dataForInformation?.revenue_range_movement > 0
                                    ? greentrendindicator
                                    : redtrendindicator
                                }
                                alt="Revenue Trend Indicator"
                              />
                            )}
                        </p>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={Companyimg}
                          alt=""
                        />
                        <p className="industry-mentions">
                          Industry/ Sector -{" "}
                          {dataForInformation?.categories
                            ?.split(/(?<=,)|\s+/) // Split by spaces while keeping commas intact
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase(),
                            )
                            .join(" ")}
                        </p>
                      </div>
                    </div>
                  ) : isPortrait
                  ? (
                    <div className="CompanyProfile-cont-rightside">
                      <div className="company-profile-mention-main">
                        <div className="company-profile-mention-b1">
                          <img
                            src={linkedin}
                            alt=""
                            style={{ width: "17px", height: "17px" }}
                          />
                          {dataForInformation?.linkedin
                            ? dataForInformation.linkedin.split(".com/")?.[1]
                            : "-"}
                        </div>
                        <div>
                          <a
                            href={dataForInformation?.linkedin}
                            target="_blank"
                          >
                            <img
                              src={visitLinkImage}
                              alt=""
                              style={{ width: "17px", height: "15px" }}
                            />
                          </a>
                        </div>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={LoctionImg}
                          alt=""
                        />
                        <p>{`${
                          dataForInformation?.street
                            ? dataForInformation?.street + `,`
                            : dataForInformation?.street === null
                              ? ""
                              : dataForInformation?.street
                        } ${
                          dataForInformation?.location_identifiers
                            ? dataForInformation?.location_identifiers + `,`
                            : dataForInformation?.location_identifiers === null
                              ? ""
                              : dataForInformation?.location_identifiers
                        } ${
                          dataForInformation?.postalcode
                            ? dataForInformation?.postalcode + `,`
                            : dataForInformation?.postalcode === null
                              ? ""
                              : dataForInformation?.postalcode
                        } ${
                          dataForInformation?.country
                            ? dataForInformation?.country
                            : dataForInformation?.country === null
                              ? ""
                              : dataForInformation?.country
                        }`}</p>
                      </div>
                      {/* <div className="CompanyProfile-content">
                        <SpeedIcon className="CompanyProfile-icons ai-score-icon" />
                        <p>
                          JOI Score -
                          {dataForInformation?.ai_score !== null &&
                          dataForInformation?.ai_score !== undefined
                            ? dataForInformation?.ai_score
                            : "NA"}
                        </p>
                      </div> */}
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={userprofile}
                          alt=""
                        />
                        <p>
                          Employees-
                          {dataForInformation?.num_employees
                            ? dataForInformation?.num_employees
                            : "Not Available"}
                          {showIndicator &&
                            dataForInformation?.num_employees_movement !==
                              0 && (
                              <img
                                style={{
                                  paddingLeft: "10px",
                                  width: "18px",
                                  height: "13px",
                                }}
                                src={
                                  dataForInformation?.num_employees_movement > 0
                                    ? greentrendindicator
                                    : redtrendindicator
                                }
                                alt="Trend Indicator"
                              />
                            )}{" "}
                        </p>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={GrowIcons}
                          alt=""
                        />
                        <p>
                          Annual revenue -
                          {dataForInformation?.revenue_range
                            ? dataForInformation?.revenue_range
                            : "Not Available"}
                          {showIndicator &&
                            dataForInformation?.revenue_range_movement !==
                              0 && (
                              <img
                                style={{
                                  paddingLeft: "10px",
                                  width: "18px",
                                  height: "13px",
                                }}
                                src={
                                  dataForInformation?.revenue_range_movement > 0
                                    ? greentrendindicator
                                    : redtrendindicator
                                }
                                alt="Revenue Trend Indicator"
                              />
                            )}
                        </p>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={Companyimg}
                          alt=""
                        />
                        <p className="industry-mentions">
                          Industry/ Sector -{" "}
                          {dataForInformation?.categories
                            ?.split(/(?<=,)|\s+/) // Split by spaces while keeping commas intact
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase(),
                            )
                            .join(" ")}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="CompanyProfile-cont-rightside">
                      <div className="company-profile-mention-main">
                        <div className="company-profile-mention-b1">
                          <img
                            src={linkedin}
                            alt=""
                            style={{ width: "17px", height: "17px" }}
                          />
                          {dataForInformation?.linkedin
                            ? dataForInformation.linkedin.split(".com/")?.[1]
                            : "-"}
                        </div>
                        <div>
                          <a
                            href={dataForInformation?.linkedin}
                            target="_blank"
                          >
                            <img
                              src={visitLinkImage}
                              alt=""
                              style={{ width: "17px", height: "15px" }}
                            />
                          </a>
                        </div>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={LoctionImg}
                          alt=""
                        />
                        <p>{`${
                          dataForInformation?.street
                            ? dataForInformation?.street + `,`
                            : dataForInformation?.street === null
                              ? ""
                              : dataForInformation?.street
                        } ${
                          dataForInformation?.location_identifiers
                            ? dataForInformation?.location_identifiers + `,`
                            : dataForInformation?.location_identifiers === null
                              ? ""
                              : dataForInformation?.location_identifiers
                        } ${
                          dataForInformation?.postalcode
                            ? dataForInformation?.postalcode + `,`
                            : dataForInformation?.postalcode === null
                              ? ""
                              : dataForInformation?.postalcode
                        } ${
                          dataForInformation?.country
                            ? dataForInformation?.country
                            : dataForInformation?.country === null
                              ? ""
                              : dataForInformation?.country
                        }`}</p>
                      </div>
                      {/* <div className="CompanyProfile-content">
                        <SpeedIcon className="CompanyProfile-icons ai-score-icon" />
                        <p>
                          JOI Score -
                          {dataForInformation?.ai_score !== null &&
                          dataForInformation?.ai_score !== undefined
                            ? dataForInformation?.ai_score
                            : "NA"}
                        </p>
                      </div> */}
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={userprofile}
                          alt=""
                        />
                        <p>
                          Employees-
                          {dataForInformation?.num_employees
                            ? dataForInformation?.num_employees
                            : "Not Available"}
                          {showIndicator &&
                            dataForInformation?.num_employees_movement !==
                              0 && (
                              <img
                                style={{
                                  paddingLeft: "10px",
                                  width: "18px",
                                  height: "13px",
                                }}
                                src={
                                  dataForInformation?.num_employees_movement > 0
                                    ? greentrendindicator
                                    : redtrendindicator
                                }
                                alt="Trend Indicator"
                              />
                            )}{" "}
                        </p>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={GrowIcons}
                          alt=""
                        />
                        <p>
                          Annual revenue -
                          {dataForInformation?.revenue_range
                            ? dataForInformation?.revenue_range
                            : "Not Available"}
                          {showIndicator &&
                            dataForInformation?.revenue_range_movement !==
                              0 && (
                              <img
                                style={{
                                  paddingLeft: "10px",
                                  width: "18px",
                                  height: "13px",
                                }}
                                src={
                                  dataForInformation?.revenue_range_movement > 0
                                    ? greentrendindicator
                                    : redtrendindicator
                                }
                                alt="Revenue Trend Indicator"
                              />
                            )}
                        </p>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={Companyimg}
                          alt=""
                        />
                        <p className="industry-mentions">
                          Industry/ Sector -{" "}
                          {dataForInformation?.categories
                            ?.split(/(?<=,)|\s+/) // Split by spaces while keeping commas intact
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase(),
                            )
                            .join(" ")}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                <div className="CompanyProfile-infomation-main">
                  <div>
                    <Accordion defaultExpanded>
                      <AccordionSummary
                        expandIcon={<KeyboardArrowDownIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                      >
                        <Typography className="company_bio_trio">
                          Organization Bio
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{ padding: isMobile ? "10px" : "8px 16px 16px" }}
                      >
                        <Typography className="CompanyProfile-infomation">
                          <p className="industry-mentions">
                            {dataForInformation?.description
                              ? dataForInformation.description.replace(
                                  /(^|\.\s+)([a-z])/g,
                                  (match) => match.toUpperCase(),
                                )
                              : "Not Available"}
                          </p>
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </div>
            </section>
            {/* mobile responsive work  */}
            {isMobile ? (
              ""
            ) : (
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  className="Companydata"
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Employees" {...a11yProps(0)} />
                  <Tab
                    label={
                      isPortrait
                        ? "CRIE"
                        : "Company and Relationship Intelligence Explorer (CRIE)"
                    }
                    {...a11yProps(1)}
                  />
                  <Tab label="News/Events" {...a11yProps(2)} />
                  <Tab label="Custom News Search" {...a11yProps(3)} />
                </Tabs>
              </Box>
            )}
          </div>
          {isMobile ? (
            <>
              <Box
                sx={{
                  backgroundColor: "#F8F9FB",
                  borderRadius: "8px",
                  p: 1,
                  width: "100%",
                  maxWidth: 420,
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "10px",
                  }}
                >
                  {["Employees", "CRIE", "News/Events", "Custom News"].map(
                    (label, index) => (
                      <Box
                        key={index}
                        onClick={() => setValue(index)}
                        sx={{
                          textAlign: "center",
                          py: "8px",
                          borderRadius: "6px",
                          fontSize: "13px",
                          fontWeight: 600,
                          cursor: "pointer",
                          userSelect: "none",
                          transition: "all 0.2s ease-in-out",

                          backgroundColor:
                            value === index ? "#E32726" : "transparent",
                          color: value === index ? "#fff" : "#7A7A7A",

                          "&:hover": {
                            backgroundColor:
                              value === index
                                ? "#E32726"
                                : "rgba(227,39,38,0.08)",
                          },
                        }}
                      >
                        {label.toUpperCase()}
                      </Box>
                    ),
                  )}
                </Box>
              </Box>
            </>
          ) : (
            ""
          )}
        </div>
        <CustomTabPanel
          value={value}
          index={0}
          className="company_tabs_data_cont"
        >
          <EmployeesTable
            isPortrait={isPortrait}
            informationData={informationData}
            favoritesLeads={favoritesLeads}
            setFavoritesLeads={setFavoritesLeads}
            listFavoriteleads={listFavoriteRecords}
            favoritesList={favoritesList}
            handleTrackingdata={handleTrackingdata}
            setValue={setValue}
            selectedOuterRows={selectedOuterRows}
            setSelectedOuterRows={setSelectedOuterRows}
            dataForInformation={dataForInformation}
            rowData={rowData}
            setIsDecisionMakerExcel={setIsDecisionMakerExcel}
            isDecisionMakerExcel={isDecisionMakerExcel}
            archiveRecord={archiveRecord}
            setArchiveRecord={setArchiveRecord}
            trackRecord={trackRecord}
            setTrackRecord={setTrackRecord}
            addToFavorite={addToFavorite}
            setAddToFavorite={setAddToFavorite}
            setDisableRequestUpdate={setDisableRequestUpdate}
            requestUpdateRecord={requestUpdateRecord}
            setRequestUpdateRecord={setRequestUpdateRecord}
            setLeadsRequestModal={setLeadsRequestModal}
            setIsSalesForceTrigger={setIsSalesForceTrigger}
            isSalesForceTrigger={isSalesForceTrigger}
            setShowSalesForce={setShowSalesForce}
            setCrieNavigate={setCrieNavigate}
            isMobile={isMobile}
          />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={1}
          disabled={isBranchLocationsDisabled}
          className="company_tabs_data_cont"
        >
          <Crie
            dataForInformation={dataForInformation}
            handleToPDFCrie={handleToPDFCrie}
            handlePrint={handlePrint}
            crieNavigate={crieNavigate}
            setCrieNavigate={setCrieNavigate}
            isDownloading={isDownloading}
            isMobile={isMobile}
          />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={2}
          disabled={isBranchLocationsDisabled}
          className="company_tabs_data_cont"
        >
          <Comingsoon
            dataForInformation={dataForInformation}
            breStatus={breStatus}
            isMobile={isMobile}
            isPortrait={isPortrait}
          />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={3}
          disabled={isBranchLocationsDisabled}
          className="company_tabs_data_cont"
        >
          <CustomNewsSearchDetails
            dataForInformation={dataForInformation}
            isMobile={isMobile}
            isPortrait={isPortrait}

          />
        </CustomTabPanel>
      </>
    </Box>
  );
}
